
    import './styles.scoped.css';
    export default {
  "universal-toolbar": "awsui_universal-toolbar_1kzri_5xie1_13",
  "with-ai-drawer": "awsui_with-ai-drawer_1kzri_5xie1_32",
  "universal-toolbar-ai-custom": "awsui_universal-toolbar-ai-custom_1kzri_5xie1_32",
  "disable-body-scroll": "awsui_disable-body-scroll_1kzri_5xie1_77",
  "toolbar-container": "awsui_toolbar-container_1kzri_5xie1_130",
  "universal-toolbar-nav": "awsui_universal-toolbar-nav_1kzri_5xie1_157",
  "universal-toolbar-breadcrumbs": "awsui_universal-toolbar-breadcrumbs_1kzri_5xie1_162",
  "universal-toolbar-drawers": "awsui_universal-toolbar-drawers_1kzri_5xie1_171",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_1kzri_5xie1_179",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_1kzri_5xie1_180",
  "drawers-trigger-content": "awsui_drawers-trigger-content_1kzri_5xie1_222",
  "group-divider": "awsui_group-divider_1kzri_5xie1_232",
  "drawers-trigger": "awsui_drawers-trigger_1kzri_5xie1_222",
  "block-body-scroll": "awsui_block-body-scroll_1kzri_5xie1_245",
  "external-breadcrumbs": "awsui_external-breadcrumbs_1kzri_5xie1_249"
};
  